import { toast as reactToast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import SuccessIcon from '@/public/images/icons/success.svg'
import ErrorIcon from '@/public/images/icons/error.svg'
import Image from 'next/image'

export const toast = (
  content: string,
  variant: 'success' | 'error' = 'success'
) => {
  reactToast(
    <div className="flex items-center gap-3">
      <div
        className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${variant === 'success' ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}
      >
        <Image
          src={variant === 'success' ? SuccessIcon : ErrorIcon}
          alt=""
          width={20}
          height={20}
          style={{
            width: 'auto',
            height: 'auto',
          }}
        />
      </div>
      <div className="text-sm font-normal">{content}</div>
    </div>
  )
}
